module.exports = __webpack_public_path__ + "static/media/ko-to-tamo-scenario-1.57615040.png";